import {css} from 'styled-components'

const variables = css`
:root {
    --black: #000000;
    --white: #FFFFFF;
    --gray: #F1F1F1;
    --light-gray: #FAFAFA;
    --dark-gray: #101010;
    --orange: #D87D4A;
    --light-orange: #FBAF85;

    --nav-height: 97px;
    --nav-height-tablet: 90px;


    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
}
`

export default variables